/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M394.247 161.587c0 24.371-19.759 44.109-44.1 44.109-24.366 0-44.125-19.738-44.125-44.109 0-24.371 19.759-44.109 44.125-44.109 24.341 0 44.1 19.738 44.1 44.11" />
      <path d="M430.902 25.6h-.256l-138.52.896c-14.051 0-27.489 5.555-37.624 15.667L41.04 250.83c-21.218 21.222-21.218 55.193-.332 76.083L185.216 470.81c10.06 10.06 23.496 15.641 37.804 15.641 14.308 0 27.72-5.555 37.855-15.641l210.108-211.968c10.008-10.036 15.562-23.476 15.562-37.76l-2.073-142.464c0-28.98-24.034-53.018-53.57-53.018m0 38.4c8.395 0 15.178 6.81 15.178 15.18l2.073 141.902c0 4.019-1.613 7.884-4.454 10.726L233.77 443.597a15.153 15.153 0 01-10.749 4.454 15.139 15.139 0 01-10.724-4.454L67.864 299.776c-5.938-5.94-5.938-15.54 0-21.478L281.632 69.35a15.172 15.172 0 0110.725-4.454L430.902 64" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconTag = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconTag.defaultProps = {
  theme,
};
IconTag.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconTag.displayName = 'IconTag';
export { IconTag };
